import React, { Component } from 'react';


class Footer extends Component {


    render() {
        return (
            <div>
                {/*  <div className="footer">
                    <div className="container">
                        <div className="footer-top_wthree_agileits">
                            <div className="col-md-4  footer-grid_w3ls_agile">
                                <div className="footer-title">
                                    <h2>About Us</h2>
                                </div>
                                <div className="footer-text">
                                    <p>We <strong>Euromax International</strong> (An <strong>ISO 9001:2015</strong> Certified Company) a introduce ourselves as Official distributor of Elco, GmbH-Germany supply for Industrial Burners &amp; Medenus Gas-Druckregeltechnik GmbH, Germany for Gas Pressure regulators <a href="#">read more</a>
                                </p>
                                </div>
                            </div>
                            <div className="col-md-4  footer-grid_w3ls_agile">
                                <div className="footer-title">
                                    <h3>Contact Us</h3>
                                </div>
                                <div className="footer-office-hour">
                                    <ul>
                                    <li className="hd">Mr. Alok Dev</li>
                                        <li className="hd">Addres :</li>
                                        <li>52C, Ground Floor, Krishna Complex, Hasanpur Village, Delhi - 110092, India</li>
                                    </ul>
                                    <ul>
                                        <li>Phone : +91-11-49046567</li>
                                        <li>Fax : +91-11-49046567</li>
                                        <li>Mobile : +91-9711139301</li>
                                    </ul>
                                    <ul>
                                        <li className="hd">Email Address : </li>
                                        <li>alok.dev@euromaxglobal.com</li>
                                    </ul>
                                </div>
                            </div>                        
                            <div className="col-md-4  footer-grid_w3ls_agile">
                                <div className="footer-title">
                                    <h3>Subscribe</h3>
                                </div>
                                <p>Get updated subscribe our news later.</p>
                                <div  method="post" className="newsletter" >
                                    <input className="email" type="email" placeholder="Enter Your Email Address" required="" />
                                    <button className="btn1"><i className="fa fa-envelope-o" aria-hidden="true"></i></button>
                                </div>
                            </div>
                            <div className="clearfix"></div>
                        </div>

                    </div>
                </div> */}

                <div className="copyright">
                    <div className="container">

                        <div className="copyright-item">
                            <div className="partner-logo">
                                <img src={process.env.PUBLIC_URL + "/assets/images/eleco.png"} />
                            </div>
                            <div className="copyrightbottom">
                                <p>© 2022 Euromax International. All Rights Reserved | Design By <a href="https://mobileinventory.in" target="_blank">Mobile Inventory</a></p>
                            </div>
                            <div className="clearfix"></div>
                        </div>

                    </div>
                </div>

            </div>
        )
    }
}

export default Footer;